export enum UserTypeEnum {
    None,
    User,
    Librarian,
    Publisher,
    Author = 4,
    Club
}

export enum UserAccess {
    None,
    Blogger,
}

